import { render } from "./TaskConfig.vue?vue&type=template&id=20941a1b"
import script from "./TaskConfig.vue?vue&type=script&lang=js"
export * from "./TaskConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__